import ajax from '../utilities/ajax';
import bugsnagClient from '../global/bugsnag';
import pathify, { commit, make } from 'vuex-pathify';
import Vue from 'vue';
import Vuex from 'vuex';

/*============================================================
 == Config
/============================================================*/

Vue.use(Vuex);
pathify.options.mapping = 'simple';

/*============================================================
 == State
/============================================================*/

const state = {
	allStores: [],
	latitude: null,
	localStore: null,
	longitude: null,
	map: null,
	stores: [],
	error: null,
	searching: false,
	googleApiKey: null,
	isCrawler: false,
	radius: 50,
	updateResultsOnNextMapEvent: false,
	query: '',
};

/*============================================================
 == Mutations
/============================================================*/

const mutations = make.mutations(state);

/*============================================================
 == Actions
/============================================================*/

const actions = {

	centerMapOnStore({ state }, store) {
		if (!state.map) return;
		commit('updateResultsOnNextMapEvent', false); // See MapWithMarkers.vue -> updateResults()
		state.map.setCenter({
			lat: store.latitude,
			lng: store.longitude
		});
		state.map.setZoom(10);
	},

	findStore({ commit, dispatch, state }) {
		commit('error', null);
		commit('searching', true);
		ajax.get(`/store-finder/a/find?query=${state.query}`)
			.then(res => {
				if (res && res.length > 0 && res[0] != null) {
					commit('stores', res);
					dispatch('centerMapOnStore', res[0]);
				} else {
					commit('stores', []);
				}
				commit('searching', false);
			})
			.catch(err => {
				commit('searching', false);
				commit('error', 'An error occurred. Please try another search.');
				bugsnagClient.notify(err);
			});;
	},

	findByMap({ commit, state }) {
		commit('error', null);
		return new Promise((resolve) => {
			ajax.post('/store-finder/a/find', {
				latitude: state.latitude,
				longitude: state.longitude,
				radius: state.radius
			}).then(res => {
				commit('stores', res);
				resolve(res);
			}).catch(err => {
				commit('error', 'An error occurred. Please try a new search.');
				bugsnagClient.notify(err);
				resolve(null);
			});;
		});
	}

};

/*============================================================
 == Store
/============================================================*/

export default new Vuex.Store({
	state,
	mutations,
	actions,
	plugins: [
		pathify.plugin
	]
});